<template>
    <div class="wizard-nav">
        <div class="wizard-steps">
            <div class="wizard-step" @click="page = 1" data-wizard-type="step"
                 :data-wizard-state="page === 1 ? 'current' : (page > 1 ? 'done' : 'pending')">
                <div class="wizard-wrapper cursor-pointer">
                    <div class="wizard-icon mr-4">
                            <span class="svg-icon svg-icon-xxl">
                                <IconUser/>
                            </span>
                    </div>
                    <div class="wizard-label">
                        <div class="wizard-title">{{ __('general.user') }}</div>
                        <div class="wizard-desc">Persönliche Angaben</div>
                    </div>
                </div>
            </div>
            <div class="wizard-step" @click="page = 2" data-wizard-type="step"
                 :data-wizard-state="page === 2 ? 'current' : (page > 2 ? 'done' : 'pending')">
                <div class="wizard-wrapper cursor-pointer">
                    <div class="wizard-icon mr-4">
                            <span class="svg-icon svg-icon-xxl">
                                <IconBoxes/>
                            </span>
                    </div>
                    <div class="wizard-label">
                        <div class="wizard-title">{{ __('agency.agency') }}</div>
                        <div class="wizard-desc">Zielagentur des Benutzers</div>
                    </div>
                </div>
            </div>
            <div class="wizard-step" @click="page = 3" data-wizard-type="step"
                 :data-wizard-state="page === 3 ? 'current' : (page > 3 ? 'done' : 'pending')">
                <div class="wizard-wrapper cursor-pointer">
                    <div class="wizard-icon mr-4">
                            <span class="svg-icon svg-icon-xxl">
                                <IconDoors/>
                            </span>
                    </div>
                    <div class="wizard-label">
                        <div class="wizard-title">{{ __('user.stores') }}</div>
                        <div class="wizard-desc">{{ __('user.stores') }} assoziieren</div>
                    </div>
                </div>
            </div>
            <div class="wizard-step" @click="page = 4" data-wizard-type="step"
                 :data-wizard-state="page === 4 ? 'current' : (page > 4 ? 'done' : 'pending')">
                <div class="wizard-wrapper cursor-pointer">
                    <div class="wizard-icon mr-4">
                            <span class="svg-icon svg-icon-xxl">
                                <IconChecks/>
                            </span>
                    </div>
                    <div class="wizard-label">
                        <div class="wizard-title">Überprüfen</div>
                        <div class="wizard-desc">Übersicht aller Eingaben</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconDoors from "@components/Icons/Keen/IconDoors.vue";
import IconChecks from "@components/Icons/Keen/IconChecks.vue";
import IconBoxes from "@components/Icons/Keen/IconBoxes.vue";
import IconUser from "@components/Icons/Keen/IconUser.vue";

export default {
    components: {
        IconUser,
        IconChecks,
        IconBoxes,
        IconDoors
    },

    props: {
        value: Number
    },

    data() {
        return {
            page: 1
        }
    },

    mounted() {
        this.page = this.value;
    },

    watch: {
        value(newValue, oldValue) {
            this.page = newValue
        },
        page(newValue, oldValue) {
            this.$emit('input', newValue)
        }
    }
}
</script>
